import { render, staticRenderFns } from "./BookMenu.vue?vue&type=template&id=d6305272&scoped=true"
import script from "./BookMenu.vue?vue&type=script&lang=ts"
export * from "./BookMenu.vue?vue&type=script&lang=ts"
import style0 from "./BookMenu.vue?vue&type=style&index=0&id=d6305272&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6305272",
  null
  
)

export default component.exports